import {AuthStorageService} from '@spartacus/core';
import {ConfigService} from '@dcp/configurator';
import jwt_decode from 'jwt-decode';
import {untilDestroyed} from '@ngneat/until-destroy';

/**
 * Checks if the current user is authorized based on roles from the JWT token.
 */
export function getAuthorized(authStorageService: AuthStorageService, configService: ConfigService, component: any): void {
  authStorageService
  .getToken()
    .pipe(untilDestroyed(component))
    .subscribe((userToken)  => {
      const roles: Array<string> = jwt_decode<any>(userToken.access_token).company_groups;
      if (roles && typeof roles === 'string') {
        component.isAuthorized = configService.getStringArray('authentication.roles')?.includes(roles);
      } else {
        component.isAuthorized = roles?.some((role) =>
          configService.getStringArray('authentication.roles')?.includes(role)
        );
      }
    });
}
